import { Spacing } from '@persona-id/design-tokens';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import Markdown from 'shared/components/Markdown';
import styled, { ThemeContext } from 'styled-components';

import CustomAssetWithFallback from 'inquiry/components/CustomAssetWithFallback';
import ThemedParagraph from 'inquiry/components/ThemedParagraph';
import ThemedTitle from 'inquiry/components/ThemedTitle';
import { useBaseStepStyleContext } from 'inquiry/context/BaseStepStyleContext';
import type {
  DeviceHandoffAssets,
  DeviceHandoffEmailPromptPageLocalizations,
} from 'lib/interfaces/StepsConfig';
import { TermsTextPosition } from 'lib/interfaces/ThemeSerialized';
import FormEmailAddress from 'verify/forms/FormEmailAddress';
import { MIN_HEIGHTS } from 'verify/styles/variables';

const Header = styled('div')`
  min-height: ${MIN_HEIGHTS.header};
  margin-bottom: ${Spacing[6]};
`;

interface InquiryDeviceHandoffEmailPromptViewProps {
  assets: DeviceHandoffAssets['device-handoff-email-prompt-page'];
  handleEmailOneTimeLink: (values: any) => void;
  localizations?: DeviceHandoffEmailPromptPageLocalizations;
  prefill: string;
  disabled: boolean;
}

export default function InquiryDeviceHandoffEmailPromptView({
  assets,
  handleEmailOneTimeLink,
  localizations,
  prefill,
  disabled,
}: InquiryDeviceHandoffEmailPromptViewProps) {
  const [t] = useTranslation();
  const { base, buttons } = useBaseStepStyleContext();
  const { deviceHandoffTermsTextPosition = TermsTextPosition.BelowButton } =
    useContext(ThemeContext);
  return (
    <>
      <CustomAssetWithFallback customImage={assets['header-pictograph']} alt='header pictograph' />
      <Header>
        <ThemedTitle styles={base?.titleStyle}>
          <Markdown>{localizations?.['title'] ?? t('to-mobile.title')}</Markdown>
        </ThemedTitle>
        <ThemedParagraph styles={base?.textStyle}>
          <Markdown>{localizations?.['prompt'] ?? t('to-email.prompt')}</Markdown>
        </ThemedParagraph>
      </Header>
      <FormEmailAddress
        onSubmit={handleEmailOneTimeLink}
        labelContinue={localizations?.['btn-submit'] ?? t('to-email.btn-submit')}
        buttonStyle={buttons?.primary}
        disclaimerStyle={base?.disclaimerStyle}
        disclaimerText={localizations?.disclaimer}
        disclaimerPosition={deviceHandoffTermsTextPosition}
        disabled={disabled}
        initialValues={{
          'email-address': prefill,
        }}
      />
    </>
  );
}
